// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"7317":"b79ab10a","8680":"fe581f21"}[chunkId] + ".css";
};